import MathFieldDialog from './MathFieldDialog';

export default MathFieldDialog;
